"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _default = _urlCatalog.default;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/urlCatalog/index.js
// module id = 693
// module chunks = 25